/*
  Pairs a checkbox with an input element.
  The checkbox can set disabled or enabled an input element.
*/
const $ = require("jquery");

function handleExtrasCheckbox(item) {
  var isChecked = $(item)
    .find("input[type=checkbox]")
    .is(":checked");
  $(item)
    .find("input[type=number]")
    .attr("disabled", !isChecked);
}

function bootstrapUpsalesFor() {
  $(".js-upsales-form-item").each(function(_, item) {
    const isInclusive = $(item)
      .find("input[type=checkbox]")
      .data("inclusive");
    if (!isInclusive) {
      handleExtrasCheckbox(item);
      $(item).on("click", function() {
        handleExtrasCheckbox(item);
      });
    }
  });
}

module.exports = {
  onLoad: bootstrapUpsalesFor
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-upsales-form/booking-upsales-form.js